<template>
  <WsUpdate
    ref="wsUpdate"
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customUpdateAction="customUpdateAction"
    :titleKey="'last_version.name'"
  >
  </WsUpdate>
</template>

<script>
import actModel from "@/models/act";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm("確認捨棄目前編輯內容嗎？");
      if (ans) {
        this.$store.dispatch("app/stopNeedSave");
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data: () => ({
    modelName: actModel.modelName,
    label: actModel.label,
    fields: actModel.fields,
    customUpdateAction: (modelData) => {
      if (modelData.range_type === "exclusive") {
        modelData.factories = [];
      }
      if (modelData.range_type === "general") {
        modelData.exclusive_factories = null;
      }
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "法規內容",
              fields: ["last_version"],
              hideLabelFields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "areas",
                "industry_categories",
                "system_classes",
                "system_subclasses",
                "act_type",
                "range_type",
                "factories",
                "exclusive_factories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "狀態",
              fields: ["act_status"],
              hideLabelFields: ["act_status"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "顯示設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["is_active"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "標籤設定",
              remark: "標籤僅供後台檢索，不影響前台使用",
              fields: ["tags"],
            },
          ],
        },
      ],
    },
  }),
};
</script>